import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const Nav = ({ content, activeIndex }) => {
    return (
        <div className={styles.nav}>
            <Chip id="260453" type="struct" title="导航" groupName="nav">
                <div className={styles.navBox}>
                    {content.map((item, index) => {
                        return (
                            <div key={index} className={`${styles.itemBox}`}>
                                <div className={`${styles.item} ${activeIndex === index ? styles.active : ''}`}>
                                    <a href={item.url} target="_blank">
                                        {item.name}
                                    </a>
                                </div>
                                {content.length - 1 !== index && <div className={styles.dot}>·</div>}
                            </div>
                        );
                    })}
                </div>
            </Chip>
        </div>
    );
};

Nav.propTypes = {
    content: PropTypes.array,
    activeIndex: PropTypes.number,
};

export default errorBoundary(Nav);
